import lib from '../../../../../app/biz/lib';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'

const SidebarSubItem = ({ to, title, fontIcon, icon, children }) => {

    const normalizedChildren = Array.isArray(children) ? children : [children];

    const checkFalseValue = (value) => {
        const result = !value
        return result
    }

    // boolean
    const checkedChildren = normalizedChildren.every((child) => checkFalseValue(child))
    // console.log(checkedChildren)

    // lib.log(checkedChildren)

    return (
        <>
            {!checkedChildren &&
                <SidebarMenuItemWithSub to={to} title={title} fontIcon={fontIcon} icon={icon}>
                    {children}
                </SidebarMenuItemWithSub>
            }
        </>
    );
};

export default SidebarSubItem;